<div class="card-body">
  <div class="row">
    <div class="col-md-12">
      <!-- <section class="example-full-width" *ngFor="let platformGroupRolePermission of platformGroupRolePermissions">
      <mat-slide-toggle color="primary" [(ngModel)]="platformGroupRolePermission.permissionValue" (change)="onChange(platformGroupRolePermission,$event)"
      labelPosition="before">{{platformGroupRolePermission.displayName}}</mat-slide-toggle>
    </section> -->
    @for (tenantPermission of tenantPermissions; track tenantPermission) {
      <section class="example-full-width">
        <a>
          <mat-slide-toggle  [disabled]="!(tenantRoles.includes(tenantPermission.name) || tenantRoles == '')" color="primary" [(ngModel)]="tenantPermission.permissionValue" (change)="onChange()"
          >{{tenantPermission.displayName}}</mat-slide-toggle>
        </a>
        <a>
          <mat-icon
            matTooltip="{{tenantPermission.description}}"
            matTooltipPosition="right"
            style="cursor: pointer; color: #303f6f;">
            info
          </mat-icon>
        </a>
      </section>
    }
  </div>
</div>
</div>